module.exports = __webpack_public_path__ + "img/box.0f843925.png";